import { createSelector } from 'reselect';

const selectOnboardTour = state => state.get('onboardTour');

export const selectOnboardActive = () =>
  createSelector(selectOnboardTour, data => data.get('active'));
